import React, { useEffect, useRef } from 'react';
import { gsap } from '../../lib/gsap';
import { educationData } from '../../data/educationData';
import './Education.css';

function Education() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from('.edu-title', {
        opacity: 0,
        y: 30,
        duration: 0.8,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: '.edu-title',
          start: 'top 85%',
        },
      });

      const items = gsap.utils.toArray('.edu-item');
      if (items.length) {
        gsap.from(items, {
          y: 24,
          opacity: 0,
          stagger: 0.12,
          duration: 0.8,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: '.edu-list',
            start: 'top 82%',
          },
        });
      }
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="edu-section" id="education" ref={sectionRef}>
      <div className="edu-inner">
        <h2 className="section-title edu-title">Education</h2>

        <div className="edu-list">
          {educationData.map((edu) => (
            <div key={edu.id} className="edu-item">
              <div className="edu-years">
                {edu.startYear} — {edu.endYear}
              </div>
              <div className="edu-content">
                <h3 className="edu-course">{edu.course}</h3>
                <span className="edu-institution">{edu.institution}</span>
              </div>
              <div className="edu-grade">{edu.grade}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Education;
